import type { FunctionComponent } from 'react'
import { useState } from 'react'

import type { StandardTextFieldProps } from '@material-ui/core/TextField'
import PhoneInput from 'react-phone-number-input'

import 'react-phone-number-input/style.css'
import { IconChevronDown, IconChevronUp } from '../Icon'
import { PhoneNumberFieldStyled } from './styles/PhoneNumberFieldStyled'

// Commonly supported country codes in the app.
// Used for setting the default country code when initializing the phone input field.
export enum DefaultCountryCodes {
  US = 'US',
  CA = 'CA',
  GB = 'GB',
}

export interface IPhoneNumberFieldProps extends StandardTextFieldProps {
  defaultCountry?: DefaultCountryCodes
}

const arrowComponent = (dropdownOpen: boolean) =>
  dropdownOpen ? (
    <IconChevronUp size={12} className={'arrow-icon'} />
  ) : (
    <IconChevronDown size={12} className={'arrow-icon'} />
  )

export const PhoneNumberField: FunctionComponent<IPhoneNumberFieldProps> = ({
  defaultCountry = DefaultCountryCodes.US,
  placeholder,
  value,
  disabled = false,
  required = false,
  onChange,
  ...props
}) => {
  const [isDropdownOpened, setIsDropdownOpened] = useState(false)
  const [showCountryFlagPlaceholder, setShowCountryFlagPlaceholder] =
    useState<boolean>(true)
  useState(false)

  return (
    <PhoneNumberFieldStyled
      isShowingPlaceholderIcon={showCountryFlagPlaceholder}
    >
      <PhoneInput
        {...(props as any)}
        error={null}
        required={required}
        international={true}
        defaultCountry={defaultCountry}
        style={{ width: '100%' }}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={onChange}
        onCountryChange={(country) => {
          setShowCountryFlagPlaceholder(country === undefined)
        }}
        countrySelectProps={{
          arrowComponent: () => arrowComponent(isDropdownOpened),
          onFocus: () => {
            setIsDropdownOpened(true)
          },
          onBlur: () => {
            setIsDropdownOpened(false)
          },
        }}
      />
    </PhoneNumberFieldStyled>
  )
}

PhoneNumberField.displayName = 'PhoneNumberField'
